import { data } from '../../svg/Cards/data';
import { makeIcon } from '../makeIcon';

export const Cards = makeIcon(data, 'cards', 'Cards');

export default Cards;
